import React from 'react'
import Select from 'react-select';
import { customStyles } from '../../../../../../../HelperFunctions';

const SelectReactJSX = ({ labelText, nameValue, onChange, value, options, isLoading, isDisabled }) => {
    return (
        <>
            <div className="col-md-12 mt-2">
                <div className='ms-2'>
                    <label htmlFor="" className='form-label  mb-0'>
                        {labelText}
                    </label>
                    <div className="icon-forms mb-3 mb-sm-0">
                        <Select
                            className='custom-selector'
                            options={options}
                            styles={customStyles}
                            name={nameValue}
                            onChange={onChange}
                            value={value}
                            isLoading={isLoading}
                            isDisabled={isDisabled}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default SelectReactJSX